import script from "./MoleculeModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeModal.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeModal.vue?vue&type=style&index=0&id=1bece3da&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bece3da"]])

export default __exports__